export default {
  getAddressData: state => state.addressEdited,
  getDefaultAddress: state => state.addressModel,
  getAddresses: state => state.addresses,
  getFreeAddresses: state => state.freeAddresses,
}
